@if (syndigoId && hasContent) {
  <section id="syndigo" [ngClass]="{ show: showSection }">
    <h2 i18n="@@product.syndigo_title">Scopri di più su questo prodotto</h2>
    <syndigo-powerpage #syndigoPowePage [attr.pageid]="syndigoId" />
  </section>
}
